const REVISION_KEY = 'pacilo.admin.expected_revision';

function readStoredRevision() {
  try {
    const raw = sessionStorage.getItem(REVISION_KEY);
    const value = Number(raw);
    if (Number.isInteger(value) && value >= 1) {
      return value;
    }
  } catch {
    // Ignore storage access failures.
  }
  return null;
}

let currentRevision = readStoredRevision();

export function getExpectedRevision() {
  if (currentRevision != null) {
    return currentRevision;
  }
  currentRevision = readStoredRevision();
  return currentRevision;
}

export function setExpectedRevision(revision) {
  const value = Number(revision);
  if (!Number.isInteger(value) || value < 1) {
    return;
  }
  currentRevision = value;
  try {
    sessionStorage.setItem(REVISION_KEY, String(value));
  } catch {
    // Ignore storage access failures.
  }
}

export function clearExpectedRevision() {
  currentRevision = null;
  try {
    sessionStorage.removeItem(REVISION_KEY);
  } catch {
    // Ignore storage access failures.
  }
}

export function captureRevision(source) {
  if (source && typeof source === 'object') {
    if (typeof source.revision === 'number') {
      setExpectedRevision(source.revision);
    }
    if (typeof source.current_revision === 'number') {
      setExpectedRevision(source.current_revision);
    }
    if (source.errors && typeof source.errors.current_revision === 'number') {
      setExpectedRevision(source.errors.current_revision);
    }
  }
  return getExpectedRevision();
}

export async function ensureExpectedRevision(loader) {
  const existing = getExpectedRevision();
  if (existing != null) {
    return existing;
  }
  if (typeof loader === 'function') {
    const data = await loader();
    captureRevision(data);
  }
  return getExpectedRevision();
}

export function withExpectedRevision(body = {}) {
  return {
    ...body,
    expected_revision: getExpectedRevision(),
  };
}
